import { useEffect, useState } from 'react';
import { api } from '../api';
import { record } from '../format';
import type { PlayerResultRow } from '../types';

/** The player-results tab: single, double and total, in matches and legs. */
export function ResultsPanel({ leagueId }: { leagueId: number }) {
  const [rows, setRows] = useState<PlayerResultRow[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api
      .playerResults(leagueId)
      .then((data) => !cancelled && setRows(data))
      .catch((err: unknown) => !cancelled && setError(String(err)));
    return () => {
      cancelled = true;
    };
  }, [leagueId]);

  return (
    <section className="card">
      <header>
        <h2>Player results</h2>
      </header>

      {error && <div className="notice error">{error}</div>}

      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th className="left">#</th>
              <th className="left">Player</th>
              <th className="left">Team</th>
              <th>Matches (single)</th>
              <th>Legs (single)</th>
              <th>Matches (double)</th>
              <th>Legs (double)</th>
              <th>Matches (total)</th>
              <th>Legs (total)</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.playerId}>
                <td className="left muted">{row.position ?? '–'}</td>
                <td className="left">{row.player}</td>
                <td className="left muted">{row.team ?? '–'}</td>
                <td className="num">{record(row.single.won, row.single.lost)}</td>
                <td className="num">{record(row.single.legsWon, row.single.legsLost)}</td>
                <td className="num">{record(row.double.won, row.double.lost)}</td>
                <td className="num">{record(row.double.legsWon, row.double.legsLost)}</td>
                <td className="num">
                  <strong>{record(row.total.won, row.total.lost)}</strong>
                </td>
                <td className="num">
                  <strong>{record(row.total.legsWon, row.total.legsLost)}</strong>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {rows.length === 0 && <div className="empty-state">Nothing imported for this league yet.</div>}
    </section>
  );
}
